import * as React from 'react';
import { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InputContext } from 'src/contexts/input.context';
import { ParserContext } from 'src/contexts/parser.context';
import { InlineInput } from 'src/components/Inputs';
import { SearchableDropdown, SearchableDropdownInputProps } from '../SearchableDropdown';
import { getTimezones } from 'src/store/app/app.getters';
import { requestTimezones } from 'src/store/app/app.actions';

export function TimeZonesDropdown() {
  const { isDisabled, isReadonly, isAutoFocus, classNames, data } = useContext(InputContext);

  const parserContext = useContext(ParserContext);

  const dispatch = useDispatch();

  const timezones = useSelector(getTimezones);

  const renderValue = useMemo(() => {
    return timezones?.find(zone => zone.id === parserContext.value)?.label;
  }, [parserContext.value, timezones]);

  const displayedValue = useMemo(() => data ?? renderValue, [data, renderValue]);

  useEffect(() => {
    if (!timezones) dispatch(requestTimezones());
  }, [dispatch, timezones]);

  function handleOnFocus(callback: () => void) {
    return function call(e: React.FocusEvent) {
      e.preventDefault();

      callback();
    };
  }

  function renderInput({
    value,
    onFocus,
    onClick,
    onBlur,
    onDiscard,
    onSubmit,
    onChange,
  }: SearchableDropdownInputProps) {
    return (
      <InlineInput
        className={classNames?.input ?? parserContext.classNames?.input}
        value={displayedValue ?? value}
        onChange={onChange}
        onFocus={handleOnFocus(onFocus)}
        onClick={onClick}
        onBlur={onBlur}
        isDisabled={isDisabled}
        autoFocus={isAutoFocus}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
        isReadonly={isReadonly ?? !parserContext.isActive}
      />
    );
  }

  return <SearchableDropdown items={timezones} renderInput={renderInput} />;
}
